"use client";

import { useState } from "react";
import { FaqData } from "../../../data/home-qna";

const Single = ({ data }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="single">
      <div className={`one ${show ? "one-open" : ""}`}>
        <div
          className="question cursor-pointer flex center-left "
          onClick={() => setShow(!show)}
        >
          <h6
            className={`transition f-s-20  f-w-400 flex-1 hover-color-blue ${
              show ? "color-blue" : ""
            }`}
          >
            {data.question}
          </h6>
          <div className="ico  b-r-100 flex center-center" >
            {show ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.426"
                height="2.6"
                viewBox="0 0 18.426 2.6"
                className="height-auto display-block"
                style={{
                  width: "20px",
                }}
              >
                <path
                  d="M2.11,1.1a1.15,1.15,0,1,0,0,2.3H17.936a1.15,1.15,0,0,0,0-2.3Z"
                  transform="translate(-0.81 -0.95)"
                  fill="#fff"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeWidth="0.3"
                />
              </svg>
            ) : (
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.585 11.5199V0.0599365H11.415V11.5199H0V12.6599H11.415V24.0599H12.585V12.6599H24V11.5199H12.585Z"
                  fill="#1C244B"
                />
              </svg>
            )}
          </div>
        </div>
        {show && (
          <div style={{ paddingTop: "10px" }}>
            <p
              className="answer font-robo p-18 "
              dangerouslySetInnerHTML={{
                __html: data.answer,
              }}
            ></p>
          </div>
        )}
      </div>
    </div>
  );
};

const Faqs = () => {
  return (
   
      <div className="flex faqs-box " >
        {/* Left */}
        <div className="  inner-box">
          <div className="all ">
            {FaqData.slice(0, 4).map((data, index) => (
              <Single key={index} data={data} />
            ))}
          </div>
        </div>

        {/* Right */}
        <div className="  inner-box">
          <div className="all ">
            {FaqData.slice(4).map((data, index) => (
              <Single key={index} data={data} />
            ))}
          </div>
        </div>
      </div>

  );
};

export default Faqs;
